// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","819":"BusinessProVisitorLazyComponent"}[chunkId] + "." + {"46":"e20c5a7ef4c5e717c679","819":"2a3e5f1733fc250e1f87"}[chunkId] + ".js";
};